import { render, staticRenderFns } from "./editdistrict.vue?vue&type=template&id=b6aec6c4"
import script from "./editdistrict.vue?vue&type=script&lang=js"
export * from "./editdistrict.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports